import type { PostHogIdentityClient } from "./types";

export function applyCanonicalIdentity(
  posthog: PostHogIdentityClient | null | undefined,
  args: { userId: string; traits?: Record<string, unknown> },
) {
  if (!posthog) {
    return;
  }

  posthog.identify?.(args.userId, args.traits);
}
